import React, { useCallback } from "react";

import { useDispatch } from "react-redux";

import { setPuzzleAndPuzzleType } from "Store/features/puzzleSlice";

import "./Quiz.css";

import PrevNextButton from "./PrevNextButton";

const QuizScreen = (props) => {
  const {
    questions,
    currentQuestion,
    setCurrentQuestion,
    score,
    setScore,
    showScore,
    setShowScore,
    editorSelectedOption,
    setEditorSelectedOption,
    editorQuestionText,
    setEditorQuestionText,
    editQuizValue,
    setEditQuizValue,
    handleAnswerOptionClick,
    decrementCurrentQuestion,
    incrementCurrentQuestion,
    onSaveEditOption,
    handleQuestionTextClick,
    onSaveQuestionText,
    onChangeQuestions,
  } = props;

  const handleSaveEditOption = useCallback(
    (index) => {
      const newQuestions = questions.map((question, questionIndex) => {
        if (questionIndex === currentQuestion) {
          const newOptions = question.options.map((option, optionIndex) => {
            if (optionIndex === index) {
              return {
                ...option,
                answerText: editQuizValue,
              };
            }
            return option;
          });
          return {
            questionText: question.questionText,
            options: newOptions,
          };
        }
        return question;
      });
      onSaveEditOption(newQuestions);
    },
    [onSaveEditOption, editQuizValue]
  );

  const handlDeleteQuestion = useCallback(() => {
    const newQuestions = questions.filter((question, questionIndex) => {
      return questionIndex !== currentQuestion;
    });
    onChangeQuestions(newQuestions);
  }, [onSaveEditOption, currentQuestion]);

  const handleCreateQuestion = useCallback(() => {
    const newQuestions = [...questions];
    newQuestions.splice(currentQuestion, 0, {
      questionText: "New Question",
      options: [
        {
          answerText: "Option 1",
          isCorrect: true,
        },
        {
          answerText: "Option 2",
          isCorrect: false,
        },
        {
          answerText: "Option 3",
          isCorrect: false,
        },
        {
          answerText: "Option 4",
          isCorrect: false,
        },
      ],
    });
    onChangeQuestions(newQuestions);
  }, [questions, onSaveEditOption, currentQuestion]);

  // if (!questions?.length) return;
  <div>
    <div className="empty-newsie-cta-text-container">Loading...</div>
  </div>;

  if (showScore) return;
  <div className="score-section">
    You scored {score} out of {questions?.length}
  </div>;

  return (
    <div className="quiz-container-layout">
      {questions?.length ? (
        <div className="question-section">
          <div className="question-count">
            Question {currentQuestion + 1} / {questions?.length}
          </div>
          <div className="modify-question-buttons-container">
            <div
              className={`modify-questions-button-container ${
                currentQuestion === 0 ? "disabled" : ""
              }`}
              onClick={decrementCurrentQuestion}
            >
              <div className="change-question-button">👈🏻</div>
              <div className="modify-question-button-text">Prev. Question</div>
            </div>
            <div
              className="modify-questions-button-container"
              onClick={handlDeleteQuestion}
            >
              <div className="delete-question-button">🗑️</div>
              <div className="modify-question-button-text">Delete Question</div>
            </div>
            <div
              className="modify-questions-button-container"
              onClick={handleCreateQuestion}
            >
              <div className="add-question-button">➕</div>
              <div className="modify-question-button-text">Add Question</div>
            </div>
            <div
              className={`modify-questions-button-container ${
                currentQuestion === questions?.length - 1 ? "disabled" : ""
              }`}
              onClick={incrementCurrentQuestion}
            >
              <div className="change-question-button">👉🏻</div>
              <div className="modify-question-button-text">Next Question</div>
            </div>
          </div>
          {editorQuestionText ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
              }}
            >
              <textarea
                type="text"
                style={{ width: 300, height: 50, resize: "none" }}
                value={editorQuestionText}
                onChange={(e) => setEditorQuestionText(e.target.value)}
              />
              <div
                className="quiz-edit-field-save"
                onClick={(e) => {
                  e.stopPropagation();
                  onSaveQuestionText(editorQuestionText);
                }}
              >
                ✔
              </div>
            </div>
          ) : (
            <div className="question-text" onClick={handleQuestionTextClick}>
              {questions[currentQuestion]?.questionText}
            </div>
          )}
        </div>
      ) : null}

      <div className="answer-section">
        {questions?.length ? (
          questions[currentQuestion]?.options.map((option, index) => (
            <div
              className={`quiz-answer ${
                option.isCorrect ? "correct" : "incorrect"
              }`}
              key={index}
              onClick={() => handleAnswerOptionClick(index)}
            >
              {editorSelectedOption === index ? (
                <div
                  className="quiz-edit-field-container"
                  onClick={(e) => e.stopPropagation()}
                >
                  <input
                    type="text"
                    value={editQuizValue}
                    onChange={(e) => setEditQuizValue(e.target.value)}
                  />
                  <div className="quiz-edit-field-buttons-container">
                    <div
                      className="quiz-edit-field-save"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSaveEditOption(index);
                        // setEditorSelectedOption(null);
                      }}
                    >
                      ✔
                    </div>
                  </div>
                </div>
              ) : (
                option.answerText
              )}
            </div>
          ))
        ) : (
          <div className="add-questions-cta" onClick={handleCreateQuestion}>
            Add some questions!
          </div>
        )}
      </div>
    </div>
  );
};

export default QuizScreen;
